'use strict'

const $ = require('jquery');
const formClassName = 'js-filter-updates'
const inputClassName = 'js-filter-updates__input'
const $inputs = $(`.${inputClassName}`)

if ($inputs.length)
  $inputs.select2({
  	placeholder: 'Search',
  	width: '100%',
  	allowClear: true
  })

$inputs.each((i, element) => {
	const $element = $(element)

	$element.on('select2:open', () => {
		$('.select2-search__field').addClass('[  c-input  c-input--text-based  ]')
	})
})

$inputs.on('change', function () {
	const $input = $(this)
	const $form = $input.parents(`.${formClassName}`)
	$form.trigger('submit')
})
